import React, { FC } from "react";
import styled from "styled-components";
import { createGlobalStyle } from "styled-components";

export const PrintStyles = createGlobalStyle`
    @media print {
        @page {
            padding: 1cm 0;
            margin:  0;
            size: auto;
        }
        
        /* Hide browser headers and footers */
        html, body {
            height: initial !important;
            overflow: initial !important;
        }
        /* Avoid content breaks between pages */
        tr, th, td, p, h1, h2, h3, h4, h5, h6 {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
        }

        /* Avoid orphaned table rows */
        table {
            page-break-inside: auto !important;
        }

        tbody tr {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
        }

        /* Control orphaned and widowed lines */
        p {
            orphans: 3; /* Minimum 3 lines at the bottom of the page */
            widows: 3;  /* Minimum 3 lines at the top of the page */
        }

        /* Keep headers with their content */
        thead {
            display: table-header-group !important;
        }

        tfoot {
            display: table-footer-group !important;
        }    }
`;

export const PrintInfo = styled.div`
    display: none;
    @media print {
        display: block;
    }
`;

export const NoPrint = styled.div`
    display: block;
    @media print {
        display: none !important;
    }
`;